import type { ComponentConfig } from '@puckeditor/core'

export interface ColumnsProps {
    columnCount: '1' | '2' | '3' | '4'
    gap: number
    verticalAlign: 'top' | 'center' | 'bottom'
    column1: any
    column2: any
    column3: any
    column4: any
}

export const ColumnsBlock: ComponentConfig<ColumnsProps> = {
    label: 'Columns',
    defaultProps: {
        columnCount: '2',
        gap: 16,
        verticalAlign: 'top',
        column1: [],
        column2: [],
        column3: [],
        column4: [],
    },
    fields: {
        columnCount: {
            type: 'radio',
            label: 'Number of Columns',
            options: [
                { label: '1', value: '1' },
                { label: '2', value: '2' },
                { label: '3', value: '3' },
                { label: '4', value: '4' },
            ],
        },
        gap: { type: 'number', label: 'Gap (px)', min: 0, max: 64 },
        verticalAlign: {
            type: 'radio',
            label: 'Vertical Align',
            options: [
                { label: 'Top', value: 'top' },
                { label: 'Center', value: 'center' },
                { label: 'Bottom', value: 'bottom' },
            ],
        },
        column1: { type: 'slot', label: 'Column 1' },
        column2: { type: 'slot', label: 'Column 2' },
        column3: { type: 'slot', label: 'Column 3' },
        column4: { type: 'slot', label: 'Column 4' },
    },
    render: ({
        columnCount,
        gap,
        verticalAlign,
        column1: Column1,
        column2: Column2,
        column3: Column3,
        column4: Column4,
    }) => {
        const count = parseInt(columnCount)
        const alignItems = verticalAlign === 'center' ? 'center' : verticalAlign === 'bottom' ? 'flex-end' : 'flex-start'

        return (
            <div style={{
                display: 'grid',
                gridTemplateColumns: `repeat(${count}, 1fr)`,
                gap,
                alignItems,
                width: '100%',
                minHeight: 48,
            }}>
                <Column1 />
                {count >= 2 && <Column2 />}
                {count >= 3 && <Column3 />}
                {count >= 4 && <Column4 />}
            </div>
        )
    },
}
